import { Fragment } from 'react';

const NotFound = () => (
    <Fragment>
      <img
        alt='No data available'
        style={{width: "3%"}}
        src={'assets/images/loading.gif' }
      />
    </Fragment>
);

export default NotFound;
